import CollectionRenderer from './CollectionRenderer';
import CountrySelectRenderer from './CountrySelectRenderer';
import DescriptionRenderer from './DescriptionRenderer';
import DescriptionSetRenderer from './DescriptionSetRenderer';
import EmptyDivRenderer from './EmptyDivRenderer';
import FieldsetDescriptionRenderer from './FieldsetDescriptionRenderer';
import InputRenderer from './InputRenderer';
import SelectRenderer from './SelectRenderer';
import TextAreaRenderer from './TextAreaRenderer';

const isCountrySelect = (item) =>
  item.__component === 'select.select' &&
  item.selectOption !== null &&
  item.selectOption.data !== null &&
  item.selectOption.data.attributes.name === 'countries';

const isStandardSelect = (item) =>
  item.__component === 'select.select' &&
  item.selectOption !== null &&
  item.selectOption.data !== null &&
  item.selectOption.data.attributes.name !== 'countries';

export const resolveRenderer = (item) => {
  switch (item.__component) {
    case 'description.description':
      return DescriptionRenderer;
    case 'description-set.description-set':
      return DescriptionSetRenderer;
    case 'fieldset-description.fieldset-description':
      return FieldsetDescriptionRenderer;
    case 'input.input':
      return InputRenderer;
    case 'field-collection.field-collection':
      return CollectionRenderer;
    case 'empty-div.empty-div':
      return EmptyDivRenderer;
    case 'text-area.text-area':
      return TextAreaRenderer;
    case 'select.select':
      if (isCountrySelect(item)) return CountrySelectRenderer;
      if (isStandardSelect(item)) return SelectRenderer;
      return null;
    default:
      return null;
  }
};

export {
  CollectionRenderer,
  CountrySelectRenderer,
  DescriptionRenderer,
  DescriptionSetRenderer,
  EmptyDivRenderer,
  FieldsetDescriptionRenderer,
  InputRenderer,
  SelectRenderer,
  TextAreaRenderer,
};
